import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';

const OtaUpdatesLogsPageContent = lazy(
  () => import('./OtaUpdatesLogsPageContent'),
);

export const OtaUpdatesLogsPage = wrapLazyNavigatorScreen(
  () => {
    return <OtaUpdatesLogsPageContent />;
  },
  {
    title: 'OTA Updates Logs',
  },
);
